// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;
}

/* 
input {
    overflow: hidden !important;
    line-height: -0.1% !important;
} */

.rcp {
  background-color: #fff !important;
  /* border: 1px solid  #1E1C1C44 !important; */
}

input[type="name"] {
  line-height: 0 !important;
}

input[type="lastName"] {
  line-height: 0 !important;
}
input[type="text"] {
  line-height: 0 !important;
}

input[type="email"] {
  line-height: 0 !important;
}

input[type="number"] {
  line-height: 0 !important;
}

input[type="password"] {
  line-height: 0 !important;
}

.tiktok-embed {
  margin: 0 !important;
}

blockquote {
  min-width: initial !important;
  max-width: initial !important;
  /* or unset; */
}

.css-vptvdy {
  max-width: none !important;
  /* or unset; */
}

.tweet-container_root__UHnkq {
  margin: 0 !important;
}

[data-testid="embed-video"] {
  max-width: initial !important;
}

.react-international-phone-country-selector-button {
  border: 0px !important;
  margin-left: 7px !important;
}

.dark .react-international-phone-country-selector-button {
  background-color: #1a1a1a !important;
}

.dark .react-international-phone-country-selector-button:hover {
  background-color: #1a1a1a !important;
}
.dark .react-international-phone-country-selector-button__dropdown-arrow {
  border-top-color: #fff !important;
}

.react-international-phone-country-selector-button__button-content {
  gap: 8.43px !important;
  padding-right: 12px !important;
  border-right: 1px solid #eee !important;
}

.react-international-phone-country-selector-button:dir(rtl)
  .react-international-phone-country-selector-button__button-content {
  border-right: none !important;
  padding-left: 0 !important;
  padding-left: 12px !important;
  border-left: 1px solid #eee !important;
}

.react-international-phone-country-selector-button__flag-emoji {
  object-fit: cover !important;
  margin: 0 !important;
}

.react-international-phone-input-container .react-international-phone-input {
  font-size: 14px !important;
  line-height: 145% !important;
  letter-spacing: -0.2px !important;
  font-weight: 400 !important;
  color: #1e1c1c !important;
}

.dark
  .react-international-phone-input-container
  .react-international-phone-input {
  background-color: #1e1c1c !important;
  color: #fff !important;
}

@media screen and (min-width: 768px) {
  .react-international-phone-input-container .react-international-phone-input {
    font-size: 18px !important;
    line-height: 140% !important;
    letter-spacing: -0.5px !important;
    font-weight: 400 !important;
    color: #1e1c1c !important;
  }
}

.nav-item,
.navbar {
  z-index: 10000;
}

.text-wk-align {
  text-align: -webkit-center;
}

.apexcharts-toolbar {
  display: none !important;
}

input[type="radio"]:checked + span {
  display: block;
}

.juBESy > input {
  display: block;
  opacity: 0;
  position: absolute;
  pointer-events: none;
}

@media screen and (max-width: 800px) {
  .juBESy > input {
    display: block;
    opacity: 0;
    position: absolute;
    pointer-events: none;
    width: -webkit-fill-available !important;
  }
  .sidebar {
    z-index: 10000000;
  }
}

.e-dlg-center-center,
.e-quick-popup-wrapper.e-device {
  z-index: 1000000 !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(216, 216, 216);
  border-radius: 40px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

/* color-picker style  */

.e-input-group:not(.e-float-icon-left),
.e-input-group.e-success:not(.e-float-icon-left),
.e-input-group.e-warning:not(.e-float-icon-left),
.e-input-group.e-error:not(.e-float-icon-left),
.e-input-group.e-control-wrapper:not(.e-float-icon-left),
.e-input-group.e-control-wrapper.e-success:not(.e-float-icon-left),
.e-input-group.e-control-wrapper.e-warning:not(.e-float-icon-left),
.e-input-group.e-control-wrapper.e-error:not(.e-float-icon-left) {
  border: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: black !important;
}

.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus,
.dark input:-webkit-autofill:active {
  box-shadow: 0 0 0px 1000px #1e1e1e inset !important;
  -webkit-text-fill-color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;;;;GAIG;;AAEH;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,2BAA2B;IAC3B,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,wCAAwC;EAC1C;EAIA;IACE,iBAAiB;EACnB;AALF;;AAQA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;;AAExB;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;EAKE,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;;;;EAKE,mDAAmD;EACnD,yCAAyC;AAC3C","sourcesContent":[".sidebar {\r\n  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;\r\n}\r\n\r\n/* \r\ninput {\r\n    overflow: hidden !important;\r\n    line-height: -0.1% !important;\r\n} */\r\n\r\n.rcp {\r\n  background-color: #fff !important;\r\n  /* border: 1px solid  #1E1C1C44 !important; */\r\n}\r\n\r\ninput[type=\"name\"] {\r\n  line-height: 0 !important;\r\n}\r\n\r\ninput[type=\"lastName\"] {\r\n  line-height: 0 !important;\r\n}\r\ninput[type=\"text\"] {\r\n  line-height: 0 !important;\r\n}\r\n\r\ninput[type=\"email\"] {\r\n  line-height: 0 !important;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  line-height: 0 !important;\r\n}\r\n\r\ninput[type=\"password\"] {\r\n  line-height: 0 !important;\r\n}\r\n\r\n.tiktok-embed {\r\n  margin: 0 !important;\r\n}\r\n\r\nblockquote {\r\n  min-width: initial !important;\r\n  max-width: initial !important;\r\n  /* or unset; */\r\n}\r\n\r\n.css-vptvdy {\r\n  max-width: none !important;\r\n  /* or unset; */\r\n}\r\n\r\n.tweet-container_root__UHnkq {\r\n  margin: 0 !important;\r\n}\r\n\r\n[data-testid=\"embed-video\"] {\r\n  max-width: initial !important;\r\n}\r\n\r\n.react-international-phone-country-selector-button {\r\n  border: 0px !important;\r\n  margin-left: 7px !important;\r\n}\r\n\r\n.dark .react-international-phone-country-selector-button {\r\n  background-color: #1a1a1a !important;\r\n}\r\n\r\n.dark .react-international-phone-country-selector-button:hover {\r\n  background-color: #1a1a1a !important;\r\n}\r\n.dark .react-international-phone-country-selector-button__dropdown-arrow {\r\n  border-top-color: #fff !important;\r\n}\r\n\r\n.react-international-phone-country-selector-button__button-content {\r\n  gap: 8.43px !important;\r\n  padding-right: 12px !important;\r\n  border-right: 1px solid #eee !important;\r\n}\r\n\r\n.react-international-phone-country-selector-button:dir(rtl)\r\n  .react-international-phone-country-selector-button__button-content {\r\n  border-right: none !important;\r\n  padding-left: 0 !important;\r\n  padding-left: 12px !important;\r\n  border-left: 1px solid #eee !important;\r\n}\r\n\r\n.react-international-phone-country-selector-button__flag-emoji {\r\n  object-fit: cover !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.react-international-phone-input-container .react-international-phone-input {\r\n  font-size: 14px !important;\r\n  line-height: 145% !important;\r\n  letter-spacing: -0.2px !important;\r\n  font-weight: 400 !important;\r\n  color: #1e1c1c !important;\r\n}\r\n\r\n.dark\r\n  .react-international-phone-input-container\r\n  .react-international-phone-input {\r\n  background-color: #1e1c1c !important;\r\n  color: #fff !important;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .react-international-phone-input-container .react-international-phone-input {\r\n    font-size: 18px !important;\r\n    line-height: 140% !important;\r\n    letter-spacing: -0.5px !important;\r\n    font-weight: 400 !important;\r\n    color: #1e1c1c !important;\r\n  }\r\n}\r\n\r\n.nav-item,\r\n.navbar {\r\n  z-index: 10000;\r\n}\r\n\r\n.text-wk-align {\r\n  text-align: -webkit-center;\r\n}\r\n\r\n.apexcharts-toolbar {\r\n  display: none !important;\r\n}\r\n\r\ninput[type=\"radio\"]:checked + span {\r\n  display: block;\r\n}\r\n\r\n.juBESy > input {\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  .juBESy > input {\r\n    display: block;\r\n    opacity: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n    width: -webkit-fill-available !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  .sidebar {\r\n    z-index: 10000000;\r\n  }\r\n}\r\n\r\n.e-dlg-center-center,\r\n.e-quick-popup-wrapper.e-device {\r\n  z-index: 1000000 !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: rgb(216, 216, 216);\r\n  border-radius: 40px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background-color: transparent;\r\n}\r\n\r\n/* color-picker style  */\r\n\r\n.e-input-group:not(.e-float-icon-left),\r\n.e-input-group.e-success:not(.e-float-icon-left),\r\n.e-input-group.e-warning:not(.e-float-icon-left),\r\n.e-input-group.e-error:not(.e-float-icon-left),\r\n.e-input-group.e-control-wrapper:not(.e-float-icon-left),\r\n.e-input-group.e-control-wrapper.e-success:not(.e-float-icon-left),\r\n.e-input-group.e-control-wrapper.e-warning:not(.e-float-icon-left),\r\n.e-input-group.e-control-wrapper.e-error:not(.e-float-icon-left) {\r\n  border: none;\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ninput:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\r\n  box-shadow: 0 0 0px 1000px white inset !important;\r\n  -webkit-text-fill-color: black !important;\r\n}\r\n\r\n.dark input:-webkit-autofill,\r\n.dark input:-webkit-autofill:hover,\r\n.dark input:-webkit-autofill:focus,\r\n.dark input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0px 1000px #1e1e1e inset !important;\r\n  box-shadow: 0 0 0px 1000px #1e1e1e inset !important;\r\n  -webkit-text-fill-color: white !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
